import React from 'react';
import { matchPath } from 'react-router';
// eslint-disable-next-line no-restricted-imports
import { IStyle, Link as FluentUILink } from '@fluentui/react';
import { useNavigation } from 'common/hooks/useNavigation';
import TelemetryProvider from 'common/utilities/TelemetryProvider';
import { mergeWith } from 'lodash';
import { routes } from 'Routes';

import { ILinkProps } from './Link.types';

const subtleLinkStyles = {
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover, &:focus, &:active, &:active:hover': {
    textDecoration: 'none',
    color: 'initial',
  },
} as IStyle;

export const Link = (props: ILinkProps) => {
  const { href, onClick, styles, subtle = false, telemetryEventName, telemetryProps, telemetryEventGroup, ...otherProps } = props;

  const { navigateTo } = useNavigation();
  const useFastNavigate = React.useMemo(() => (href ? routes.some((route) => matchPath(href, route)) : false), [href]);

  const onLinkClick = React.useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if (onClick || href) {
        if (telemetryEventName) {
          TelemetryProvider.Instance.logUserActivity(telemetryEventName, telemetryEventGroup || 'ClickActivity', telemetryProps);
        }

        if (onClick) {
          onClick(e);
        }

        // if the link is to a Gibralatar route and if event default was not prevented from onClick handler
        // then do a fast switch.
        if (href && useFastNavigate && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.defaultPrevented && !otherProps.target) {
          navigateTo(href);
          e.preventDefault();
        }
      }
    },
    [onClick, href, telemetryEventName, useFastNavigate, otherProps.target, telemetryEventGroup, telemetryProps, navigateTo]
  );

  return (
    <FluentUILink
      href={href}
      onClick={onLinkClick}
      styles={subtle ? mergeWith({}, styles, { root: subtleLinkStyles }) : styles}
      {...otherProps}
    />
  );
};
